import { render, staticRenderFns } from "./Developpers.vue?vue&type=template&id=aba413d6"
import script from "./Developpers.vue?vue&type=script&lang=js"
export * from "./Developpers.vue?vue&type=script&lang=js"
import style0 from "./Developpers.vue?vue&type=style&index=0&id=aba413d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports